import {
  CloseCircleOutlined,
  PlusOutlined
} from "@ant-design/icons";
import classPopup from "@src/models/control/popup";
import {
  Button,
  Input,
  Modal
} from "antd";
import React, { useState } from "react";
import { COMMON_CONSTANT, KEY, lang } from "../../constants/common.const";
import BoxSearchItemIoT from "./BoxSearchItemIoT";
import { showMessage } from "../../constants/utils";
export function ModalBoxItemIoT({
    onSubmit,
    setShowLoading,
    value,
    clicksaved,
    currentData,
    ...props
  }) {
    const [popupIoT, setPopupIoT] = useState({
      ...new classPopup(),
    });
  
    const [checkedList, setCheckedList] = useState([]);
  
    // add ItemIOT
  const onAddItemIoT = () => {
    if (checkedList.length > 0) {
      onSubmit(checkedList[0]);
      setCheckedList([]);
      setPopupIoT({ ...popupIoT, show: false });
    } else {
      showMessage(KEY.WARMING, "項目を選択してください");
    }
  }
    return (
      <>
        <Input.Search
        className={`${props.className} inputIot`}
          style={props.style}
          value={value}
          onChange={props.onChange}
          onSearch={() => setPopupIoT({ ...popupIoT, show: true })}
         
        />
        <Modal
          className="box-search-machine"
          centered
          title={COMMON_CONSTANT.TITLE_CREATE_GROUP}
          visible={popupIoT.show}
          onCancel={() => {
            setPopupIoT({ ...popupIoT, show: false });
          }}
          footer={[
            <Button
              key={2}
              onClick={() => {
                setPopupIoT({ ...popupIoT, show: false });
              }}
            >
              <CloseCircleOutlined />
              {lang.CANCEL}
            </Button>,
            <Button
              key={1}
              className="buttonPC button--info"
              onClick={onAddItemIoT}
            >
              <PlusOutlined />
              {COMMON_CONSTANT.ADD}
            </Button>,
          ]}
        >
          <BoxSearchItemIoT
            setLoading={setShowLoading}
            listFilter={currentData}
            checkedList={[checkedList, setCheckedList]}
            isOneValue={true}
            defaultValue={value}
          />
        </Modal>
      </>
    );
  }
  